import { observable } from "mobx";

class PhotoEditingLabel {
  /**
   * @property {number|null}
   */
  @observable photoEditingLabelId = null;

  /**
   * @property {string}
   */
  @observable name = "";

  constructor({ photoEditingLabelId = null, name = "" }) {
    this.photoEditingLabelId = photoEditingLabelId;
    this.name = name;
  }
}

export default PhotoEditingLabel;
